export class PhoneHelper {
  static getFormattedPhoneNumber (phoneNumber: string) {
    const cleaned = phoneNumber.replace(/[^\d]/g, '').replace(/^0+/, '');
    return cleaned || '';
  };
}
